import { types } from "../types/types";

export const uiOpenModalPdf = () => ({
    type: types.uiOpenModalPdf
});

export const uiCloseModalPdf = () => ({
    type: types.uiCloseModalPdf
});

export const uiSetPdfBlob = (blob, filename) => ({
    type: 'uiSetPdfBlob',
    payload:{ blob, filename}
});

export const uiClearPdfBlob = () => ({
    type: 'uiClearPdfBlob',
});